import { Component, EventEmitter, Input, Output, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Subject } from 'rxjs';
import { TimeApiService } from 'cbc-shared-lib';
import { takeUntil } from 'rxjs/operators';
import {
  Sgkb702aResInclusioncontractInclutagsupdemandctrSearchresultDto,
  Sgkb702aResInclusiveCtrInfoDto
} from 'sg-api';
import { SgkbConstains } from '../../../../../sg-kb-shared/sg-kb-constans';

@Component({
  selector: 'app-sgkb701d-search-result',
  templateUrl: './sgkb701d-search-result.component.html',
  styleUrl: './sgkb701d-search-result.component.scss'
})
export class Sgkb701dSearchResultComponent implements OnInit, OnDestroy {

  /** 遷移元ステータス */
  @Input() mode: string;
  /** 包括契約検索APIレスポンス */
  @Input() incCtrSearchResultList: Sgkb702aResInclusioncontractInclutagsupdemandctrSearchresultDto;

  /** 行がクリックされたときのイベント*/
  @Output() rowClickEvent = new EventEmitter<string>();

  // @ViewChild(MatSort) sort: MatSort;
  @ViewChild('sort1', { static: true }) sort: MatSort;

  private onDestroy$ = new Subject();

  setDisplay: String;

  /** マウスオーバーされた行の情報を格納 */
  selectedRow: string = '';

  /** 検索結果表示リスト */
  displayedColumnsCol: string[] = [
    'inclusioncontractVisitornumber',
    'inclusioncontractVisitormei',
    'inclusioncontractStateCodeaname',
    'registrationapplicationJokyoCodeaname',
    'inclusioncontractStartdate',
    'inclusioncontractExpirationdate',
    'ctrConclusionSosikianame',
    'contractdateconclusionStaffname',
    'inclusioncontractRrkno',
    'inclusioncontractYearnaiSrno',
    'inclusioncontractStcode',
  ];

  dataSource = new MatTableDataSource<Sgkb702aResInclusiveCtrInfoDto>();

  /** 業務日付 */
  bussinessDate: string;

  /** 解約申請状況名称 */
  CANCEL_APPLY: string = "解約申請中";
  CANCEL_APPROVED: string = "解約承認済";

  /**
   * コンストラクタ
   * @memberof Sgkb701dSearchResultComponent
   */
  constructor(private timeApiService: TimeApiService) { }

  /**
   * 初期表示処理
   * @memberof Sgkb701dSearchResultComponent
   */
  ngOnInit(): void {
    // 業務日付を更新
    this.timeApiService.updateBussinessDate();
    // 業務日付取得
    this.timeApiService.bussinessDate.pipe(takeUntil(this.onDestroy$)).subscribe(businessDate => {
      this.bussinessDate = businessDate;
    });

    // レスポンスの包括契約情報リストを設定
    this.dataSource.data = this.incCtrSearchResultList.inclusiveCtrInfoList;

    for (let i = 0; i < this.dataSource.data.length; i++) {

      // 業務日付をDate型に変換
      const afterConvBusinessDate = this.timeApiService.convertStringToDate(this.bussinessDate);
      // 解約日をDate型に変換
      const afterConvIncTermDate = this.timeApiService.convertStringToDate(
        this.dataSource.data[i].inclusioncontractTerminationdate);
      // 通常は包括契約検索API(SGKB702A)のレスポンスの登録申請状況コード名称を申請状況に設定し画面表示しているが、
      // 解約の場合に限り、固有に値を設定している。
      // 解約申請状況コードが申請中の場合、申請状況を「解約申請中」とする
      if (this.dataSource.data[i].inclusioncontractBreakereqestJokycd == SgkbConstains.CODE.HOUKATSU_CANCEL_APLY_CD.APPLY) {
        this.dataSource.data[i].registrationapplicationJokyoCodeaname = this.CANCEL_APPLY;

        // 解約申請状況コードが承認済の場合、申請状況を「解約承認済」とする
      } else if (this.dataSource.data[i].inclusioncontractBreakereqestJokycd == SgkbConstains.CODE.HOUKATSU_CANCEL_APLY_CD.APPROVED) {
        this.dataSource.data[i].registrationapplicationJokyoCodeaname = this.CANCEL_APPROVED;
      }

      // 包括契約状態コードが 解約 の場合
      if (this.dataSource.data[i].inclusioncontractStcode == SgkbConstains.CODE.HOUKATSU_CNTRCT_CD.CANCEL) {
        // 業務日付が解約日より当日を含む過去日の場合
        if (this.timeApiService.compDateYyyyMmDd(
          afterConvBusinessDate, afterConvIncTermDate, true)) {
          // 契約中
          this.dataSource.data[i].inclusioncontractStateCodeaname = SgkbConstains.CODE_NAME.HOUKATSU_CNTRCT_CD_NAME.CNTRCT;
        } else {
          // 解約
          this.dataSource.data[i].inclusioncontractStateCodeaname = SgkbConstains.CODE_NAME.HOUKATSU_CNTRCT_CD_NAME.CANCEL;
        }

        // 契約終了日に解約日を設定
        this.dataSource.data[i].inclusioncontractExpirationdate =
          this.dataSource.data[i].inclusioncontractTerminationdate;

      }
      // 包括契約状態コードが 契約中 の場合
      else if (this.dataSource.data[i].inclusioncontractStcode == SgkbConstains.CODE.HOUKATSU_CNTRCT_CD.CNTRCT) {
        // 業務日付が解約日より当日を含む過去日の場合は、レスポンスの包括契約状態コード名称を設定しているため処理不要
        // 契約終了日には、レスポンスの契約満了日を設定しているため処理不要
        // 業務日付が解約日より当日を含む過去日ではない場合
        if (!this.timeApiService.compDateYyyyMmDd(
          afterConvBusinessDate, afterConvIncTermDate, true)) {
          this.dataSource.data[i].inclusioncontractStateCodeaname = SgkbConstains.CODE_NAME.HOUKATSU_CNTRCT_CD_NAME.EXPIRED;
        }
      }
      // 包括契約状態コードが 1(空白) の場合
      else if (this.dataSource.data[i].inclusioncontractStcode == SgkbConstains.CODE.HOUKATSU_CNTRCT_CD.NONE) {
        this.dataSource.data[i].inclusioncontractStateCodeaname = SgkbConstains.CODE_NAME.HOUKATSU_CNTRCT_CD_NAME.NONE;
      }
    }
  }

  /**
   * 購読を停止する処理
   * @memberof Sgkb701dSearchResultComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * ソート処理
   * @memberof Sgkb701dSearchResultComponent
   */
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  /**
   * 行選択時の処理
   * @memberof Sgkb701dSearchResultComponent
   */
  onClickRow(row, event = null): void {
    // 表ラベル活性の場合のみ行選択処理を実行
    if (this.isTableLabelEnable(row)) {
      this.rowClickEvent.emit(row);
    }
  }

  /**
   * リストのマウスオーバー処理
   * @memberof Sgkb701dSearchResultComponent
   */
  onMouseoverRow(key: string): void {
    this.selectedRow = key;
  }

  /**
   * リストのマウスアウト処理
   * @memberof Sgkb701dSearchResultComponent
   */
  onMouseoutRow(): void {
    this.selectedRow = '';
  }

  /**
   * 表ラベルの活性・非活性判定処理
   * @memberof Sgkb701dSearchResultComponent
   */
  isTableLabelEnable(row): boolean {
    // 表ラベル活性フラグ（true：活性、false：非活性）
    let isEnableFlg: boolean = false;

    // 照会画面からの遷移の場合
    if (this.mode == 'read') {
      // 活性
      isEnableFlg = true;
    }

    // 期中変更画面、契約更改画面、解約画面からの遷移の場合
    if (this.mode == 'midterm_change'
      || this.mode == 'renewal'
      || this.mode == 'cancel') {

      // 最新識別コードおよび年度内最新識別コードが 最新 の場合
      if (row.latestDiscrmCode == SgkbConstains.CODE.LATEST_IDENTIFI_CD.LATEST
        && row.inclusioncontractYearnaiLatestdiscriminationcode == SgkbConstains.CODE.LATEST_IDENTIFI_CD.LATEST) {
        // 活性
        isEnableFlg = true;
      } else {
        // 非活性
        isEnableFlg = false;
      }
    }

    // 承認画面、取消画面からの遷移の場合
    if (this.mode == 'approve'
      || this.mode == 'delete') {

      // 登録申請状況コードが 申請中 の場合
      if (row.inclusioncontractRegistrationapplicationJokycd == SgkbConstains.CODE.HOUKATSU_CNTRCT_RGST_APLY_CD.APPLY) {

        // 包括契約登録種別コードが 新規契約
        // かつ 最新識別コードおよび年度内最新識別コードが 最新 の場合
        if (row.inclusioncontractRegistrationapplicationClscode == SgkbConstains.CODE.HOUKATSU_CNTRCT_REGIST_CLY_CD.NEW_CNTRCT
          && row.latestDiscrmCode == SgkbConstains.CODE.LATEST_IDENTIFI_CD.LATEST
          && row.inclusioncontractYearnaiLatestdiscriminationcode == SgkbConstains.CODE.LATEST_IDENTIFI_CD.LATEST) {
          // 活性
          isEnableFlg = true;
        }

        // 包括契約登録種別コードが 期中契約変更
        // かつ 最新識別コードおよび年度内最新識別コードが 最新ではない の場合
        if (row.inclusioncontractRegistrationapplicationClscode == SgkbConstains.CODE.HOUKATSU_CNTRCT_REGIST_CLY_CD.MID_CHANGE
          && row.latestDiscrmCode == SgkbConstains.CODE.LATEST_IDENTIFI_CD.NOT_LATEST
          && row.inclusioncontractYearnaiLatestdiscriminationcode == SgkbConstains.CODE.LATEST_IDENTIFI_CD.NOT_LATEST) {
          // 活性
          isEnableFlg = true;
        }

        // 包括契約登録種別コードが 契約更改
        // かつ 最新識別コードが 最新ではない
        // かつ 年度内最新識別コードが 最新 の場合
        if (row.inclusioncontractRegistrationapplicationClscode == SgkbConstains.CODE.HOUKATSU_CNTRCT_REGIST_CLY_CD.RENEWAL
          && row.latestDiscrmCode == SgkbConstains.CODE.LATEST_IDENTIFI_CD.NOT_LATEST
          && row.inclusioncontractYearnaiLatestdiscriminationcode == SgkbConstains.CODE.LATEST_IDENTIFI_CD.LATEST) {
          // 活性
          isEnableFlg = true;
        }

      }
      // 解約申請状況コードが 申請中 の場合
      else if (row.inclusioncontractBreakereqestJokycd == SgkbConstains.CODE.HOUKATSU_CANCEL_APLY_CD.APPLY) {
        // 活性
        isEnableFlg = true;
      }
      // 上記以外の場合
      else {
        // 非活性
        isEnableFlg = false;
      }
    }
    return isEnableFlg;
  }
}
